const createStorageUtil = (storage) => ({
  get: (key) => {
    const value = storage.getItem(key);
    return value ? JSON.parse(value) : value;
  },
  set: (key, data) => {
    const value = typeof data === "string" ? data : JSON.stringify(data);
    storage.setItem(key, value);
  },
  remove: (key) => {
    storage.removeItem(key);
  },
});

export const userStorage = (useLocal = true) =>
  createStorageUtil(useLocal ? localStorage : sessionStorage);

export const tokenStorage = (useLocal = true) =>
  createStorageUtil(useLocal ? localStorage : sessionStorage);